
import { defineComponent, onMounted, ref, reactive } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

import DetailOrder from "@/components/1crm/product/data-order/detail-order.vue";

export default defineComponent({
  name: "detail-order",
  components: {
    ErrorMessage,
    Field,
    Form,
    DetailOrder,
  },

  setup() {
    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH);
      setCurrentPageBreadcrumbs("Detail Pesanan", ["Data"]);
    });
  },
});
